module.exports = __webpack_public_path__ + "img/5.70369d21.jpg";